import { useLocation } from "react-router-dom";
import { useFestivalTheme } from "@/context/FestivalThemeContext";

/**
 * FestParticles — slow golden dust drifting across the homepage during the
 * Diwali theme. Fixed behind all content (z-0), pointer-events none,
 * transform/opacity only, and removed entirely for prefers-reduced-motion.
 * Homepage only; catalogue/PRIME/checkout stay clean.
 */
const PARTICLES = Array.from({ length: 16 }, (_, i) => ({
  left: (i * 61 + 7) % 96,
  top: 8 + ((i * 37) % 84),
  size: 2 + (i % 3),
  dur: 15 + (i % 5) * 4,
  delay: -(i * 1.7),
}));

export default function FestParticles() {
  const { isFestival } = useFestivalTheme();
  const { pathname } = useLocation();
  if (!isFestival || pathname !== "/") return null;

  return (
    <div className="pq-gold-particles" aria-hidden="true" data-testid="fest-gold-particles">
      {PARTICLES.map((p, i) => (
        <span
          key={i}
          className="pq-gold-dot"
          style={{
            left: `${p.left}%`,
            top: `${p.top}%`,
            width: p.size,
            height: p.size,
            animationDuration: `${p.dur}s`,
            animationDelay: `${p.delay}s`,
          }}
        />
      ))}
    </div>
  );
}
